const schemaCache = new Map<string, JSONSchema>();

export type JSONSchema = Record<string, unknown>;

// todo: put schemas behind rest api/cdn
// + centralize logic to bundle coupled schemas that use refs
// + we always get latest versions instead of updating dependencies
// + no need to bundle all schemas upfront (unnecessary overhead)
// - need to handle async somewhere (separate init method?)

(function initialize() {
  const schemaFiles = require.context('@esmiley/schemas/dist', false, /\.json$/);
  schemaFiles.keys().forEach((key) => {
    const file = key.split('/').pop();
    const name = file.split('.')[0];
    // eslint-disable-next-line
    schemaCache.set(name, require(`@esmiley/schemas/dist/${file}`));
  });

  // A directory that resolves but holds no schemas would leave every validation
  // silently passing, so an empty cache has to fail the build instead.
  if (schemaCache.size === 0) {
    throw new Error('@esmiley/schemas/dist resolved but contained no schemas');
  }
})();

export const getSchemas = () => schemaCache;
